



















import Vue from "vue";

import TtLogo from "@joyz/app-core/assets/logo/terratalk-logo-fullcolor.svg";

interface Props {
  cardIcon: string;
  title: string;
  titleIcon?: string;
}

export default Vue.extend<Props>({
  name: "AuthCard",
  functional: true,
  props: {
    cardIcon: { type: String, default: TtLogo },
    title: { type: String, required: true },
    titleIcon: { type: String, default: undefined }
  }
});
